export default __webpack_public_path__ + "static/media/configr-mail.b9e789ee.svg";